"use client";

import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";

import { useTileInteractions } from "./TileInteractionsContextProvider";

export const ProductLink: React.FC<{
  dataTestId?: string;
  children: React.ReactNode;
}> = (props) => {
  const context = useTileInteractions();

  const onClick = () => {
    context?.tileActions?.onProductClick?.(context?.props?.productToken ?? "");
  };

  return (
    <Link
      onClick={onClick}
      data-test-id={props.dataTestId ?? "product-tile-link"}
      to={context?.props?.productLinkProps?.productUrl ?? ""}
      replace={context?.props?.productLinkProps?.replace}
      onMouseDown={context?.tileActions?.onMouseDown}
      onTouchStart={context?.tileActions?.onTouchStart}
    >
      {props.children}
    </Link>
  );
};
